import React, { Component } from 'react'

import FeeList from './feeList'

import request from 'request'

import { format, formatWithOptions, subMonths } from 'date-fns/fp'
import * as R from 'ramda'

class ServiceFeeList extends Component {
  constructor(props) {
    super(props);

  }

  render() {
    const columnsList = [['月份', 'time'], ['小程序', 'extInfo'], ['服务费收费维度', 'condition'], ['金额', 'feeTotal']];
    const api = request.api.getServiceFeeList;
    const dataKey = 'serviceFee';

    const dataFormatter = data => {
      const typeList = data.types;

      const getCurrentType = type => typeList.find(item => item.type == type)

      if (!data[dataKey]) {
        return []
      } else {
        return data[dataKey].map((item, idx) => {
          const currentTypeItem = getCurrentType(item.condition.type);

          return Object.assign(item, {
            condition: `${currentTypeItem.name}为${item.condition.condition}${currentTypeItem.unit}`,
            feeTotal: `${item.fee / 100}虎牙币`,
            key: idx,
          })
        })
      }
    }

    const startTime = R.compose(
      format('yyyy-MM'),
      subMonths(1),
    )(new Date())

    return (
      <div>
        <FeeList columnsList = {columnsList} api = {api} dataFormatter = {dataFormatter} startTime = {startTime}></FeeList>
      </div>
    )
  }
}

export default ServiceFeeList;
